import css from './queueControl.module.scss';

import { memo, useCallback } from 'react';

import { apiUndoFinishWord } from 'core/api';
import { useMessageModal } from 'core/ui/MessageModal';
import { Icon } from 'core/ui/icons';

type TProps = {
  undo: TUndo;
  setUndo: (undo: null) => void;
  goPrev: () => void;
  onUpdateWord: (word: TWord) => void;
};
const UndoButton = ({ setUndo, undo, onUpdateWord, goPrev }: TProps) => {
  const { showError } = useMessageModal();
  const onClick = useCallback(async () => {
    try {
      onUpdateWord(await apiUndoFinishWord(undo));
      setUndo(null);
      goPrev();
    } catch (error) {
      showError(error);
    }
  }, [undo]);

  return (
    <div className={css.button} title="Undo" onClick={() => void onClick()}>
      <Icon icon="Undo" />
    </div>
  );
};

export default memo(UndoButton);
